import { GetOrderServicesResponse } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';
import { Order } from '@cemex-core/cmx-api/models/order-management/order';

export enum ReviewActionTypes {
  RESET = '[Reviews] Reset',
  SET_DRAFT_ID = '[Reviews] Set draft id',
  LOAD_DRAFT = '[Reviews] Load draft',
  LOAD_DRAFT_COMPLETE = '[Reviews] Load draft complete',
  RESET_DRAFT = '[Reviews] Reset draft',
  LOAD_PUMPING_SERVICE = '[Reviews] Load pumping service',
  LOAD_PUMPING_SERVICE_COMPLETE = '[Reviews] Load pumping service complete',
}

export class SetDraftIdAction implements Action {
  readonly type = ReviewActionTypes.SET_DRAFT_ID;

  constructor(public payload: { orderDraftId: number }) {}
}

export class LoadDraftAction implements Action {
  readonly type = ReviewActionTypes.LOAD_DRAFT;

  constructor() {}
}

export class LoadDraftCompleteAction implements Action {
  readonly type = ReviewActionTypes.LOAD_DRAFT_COMPLETE;

  constructor(public payload: { orderDraft: Order | null }) {}
}

export class ResetDraftAction implements Action {
  readonly type = ReviewActionTypes.RESET;

  constructor() {}
}

export class ResetDraftOnlyAction implements Action {
  readonly type = ReviewActionTypes.RESET_DRAFT;

  constructor() {}
}

export class LoadPumpingServiceAction implements Action {
  readonly type = ReviewActionTypes.LOAD_PUMPING_SERVICE;

  constructor(public payload: number) {}
}

export class LoadPumpingServiceCompleteAction implements Action {
  readonly type = ReviewActionTypes.LOAD_PUMPING_SERVICE_COMPLETE;

  constructor(public payload: GetOrderServicesResponse) {}
}

export type ReviewActions =
  | SetDraftIdAction
  | LoadDraftAction
  | LoadDraftCompleteAction
  | ResetDraftAction
  | ResetDraftOnlyAction
  | LoadPumpingServiceAction
  | LoadPumpingServiceCompleteAction;
